import React from 'react';
import { ColorPicker } from '@/modern/components/color-picker';
import { DropdownMenuSub, DropdownMenuSubTrigger, DropdownMenuSubContent } from '@/modern/components/ui/dropdown-menu';
import { Task } from '@/bryntum-lib/models/Task';

interface TaskColorPickerProps {
  record: Task;
  onColorChange?: (color: string | null) => void;
  disabled?: boolean;
}

export const TaskColorPicker: React.FC<TaskColorPickerProps> = ({ record, onColorChange, disabled }) => {
  const handleColorChange = (color: string | null) => {
    if (record && color) {
      record.color = color;
    }
    onColorChange?.(color);
  };

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger disabled={disabled}>
        <i className="fa-light fa-palette w-4 h-4" />
        <span>Task Color</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent className="p-0">
        <ColorPicker
          value={record?.color}
          onChange={handleColorChange}
          editable={false}
          className="border-0 shadow-none w-80"
        />
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
};